import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: [],
  selectedCategories: 'all',
  searchValue: '',
  selectedTab: 'exteriors',
  pdfModal: false,
  saveConfigModal: false,
  offerModal: false,
  offerModalType: 'offer',
  locationCode: '1',
  captchaToken: null
};

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    addFilter: (state, { payload }) => {
      state.filters = [...state.filters, payload];
    },
    removeFilter: (state, { payload }) => {
      state.filters = state.filters.filter(item => item !== payload);
    },
    setSelectedCategory: (state, { payload }) => {
      state.selectedCategories = payload;
    },
    setSearchValue: (state, { payload }) => {
      state.searchValue = payload;
    },
    setSelectedTab: (state, { payload }) => {
      state.selectedTab = payload;
    },
    setModalState: (state, { payload }) => {
      const { modal, newState, type } = payload;
      if (type) state.offerModalType = type;
      if (state.hasOwnProperty(modal)) {
        state[modal] = newState;
      }
    },
    setLocation: (state, { payload }) => {
      state.locationCode = payload;
    },
    setCaptchaToken: (state, { payload }) => {
      state.captchaToken = payload;
    },
    resetAppState: state => initialState,
  },
});

export const {
  addFilter,
  removeFilter,
  setSearchValue,
  resetAppState,
  setSelectedTab,
  setModalState,
  setLocation,
  setCaptchaToken,
} = slice.actions;

export default slice.reducer;
